import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { SignoPlan } from '@interfaces/interface-bakend/entidades/signo-plan.interface';
import { SignoPlanService } from '@services/entidades/signo-planes.service';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { MediaService } from 'src/app/services/shared/media.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-plan-modificacion',
  templateUrl: './plan-modificacion.component.html',
  styleUrls: ['./plan-modificacion.component.scss']
})
export class PlanModificacionComponent implements OnInit, OnDestroy {
  form: FormGroup;
  signoPlan: SignoPlan;
  flagLoaded: boolean = false;

  // Upload variables
  flagSelectFile = false;
  selectedFile: any;
  value = 0;
  cargandoArchivo = false;
  subscriptionAvance: Subscription;
  fileName = 'No file selected';
  file: File;

  constructor(
    private router: Router,
    private signoPlanService: SignoPlanService,
    private mediaService: MediaService,
    private guiMsjService: GuiMsjService,
    private signoAuditoriaService: SignoAuditoriaService,
  ) { }

  ngOnInit(): void {
    this.getEstadoPlan();
    this.createForm();
    this.subscribeAvanceUpload();
  }

  ngOnDestroy(): void {
    if (this.subscriptionAvance) {
      this.subscriptionAvance.unsubscribe();
    }
  }

  get idRefNoValido() {
    return this.form.get('identificacion').invalid;
  }

  get planNoValido() {
    return this.form.get('denominacion').invalid;
  }

  createForm() {
    this.form = new FormGroup({
      identificacion: new FormControl(this.signoPlan?.idRef, [
        Validators.required,
        Validators.maxLength(50)
      ]),
      denominacion: new FormControl(this.signoPlan?.denominacion, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
      ]),
      pdf: new FormControl(''),
      activoDescarga: new FormControl(this.signoPlan?.activoDescarga || false),
      leyendaUsuario: new FormControl(this.signoPlan?.leyendaUsuario || ''),
    });
  }

  async getPlan() {
    return (this.signoPlan = this.signoPlanService.getPlanSeleccionado());
  }

  async getEstadoPlan() {
    if (this.getPlan() === undefined) {
      await this.router.navigateByUrl('/planes-listado');
    } else {
      await this.getPlan();
      this.flagLoaded = true;
      this.signoAuditoriaService.registrarEvento({
        accion: 'PANTALLA_ACCESO',
        modulo: 'Planes',
        pantalla: 'PlanModificacion',
        ruta: '/plan-modificacion',
        payload: {
          planId: this.signoPlan._id,
          denominacion: this.signoPlan.denominacion,
        },
        resultado: 'EXITO',
      });
    }
  }

  async updatePlan() {
    await this.guiMsjService.msjFormSubmit('Guardando');
    await this.signoPlanService.updatePlan(this.signoPlan._id, await this.setDataForma());
    let uploadExitoso = true;
    if (this.selectedFile) {
      uploadExitoso = await this.uploadFile(this.selectedFile, this.signoPlan._id);
    }
    const pdfSubido = !!this.selectedFile;
    this.signoAuditoriaService.registrarEvento({
      accion: pdfSubido ? 'EDITAR_CON_PDF' : 'EDITAR_SIN_PDF',
      recurso: 'Plan',
      modulo: 'Planes',
      pantalla: 'PlanModificacion',
      ruta: '/plan-modificacion',
      payload: {
        planId: this.signoPlan._id,
        idRef: this.form.value.identificacion,
        denominacion: this.form.value.denominacion,
        pdfSubido,
        pdfFilename: this.selectedFile?.name || null,
        pdfAnterior: this.signoPlan.pdf || null,
      },
      resultado: uploadExitoso ? 'EXITO' : 'ERROR',
    });
    await this.guiMsjService.msjFormSubmit('DatosGuardados');
    this.router.navigateByUrl('/planes-listado');
  }

  async setDataForma(): Promise<SignoPlan> {
    const plan: SignoPlan = {
      idRef: this.form.value.identificacion,
      denominacion: this.form.value.denominacion || "",
      activoDescarga: this.form.value.activoDescarga || false,
      leyendaUsuario: this.form.value.leyendaUsuario || "",
    };

    return plan;
  }

  /* UPLOAD */
  subscribeAvanceUpload() {
    this.subscriptionAvance = this.mediaService.getAvance().subscribe(resp => {
      if (resp) {
        this.value = resp.value;
      } else {
        this.value = 0;
      }
    });
  }

  openFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
  }

  onChangeFile(file: File, event) {
    if (file) {
      this.openFileSelected(event);
      this.fileName = file.name;
      this.file = file;
    }
  }

  async uploadFile(selectedFile, idplan): Promise<boolean> {
    this.cargandoArchivo = true;
    return this.mediaService.uploadPdfPlan(selectedFile, idplan).then(resp => {
      if (resp) {
        if (this.value === 100) { this.cargandoArchivo = false; }
        return true;
      } else {
        this.guiMsjService.msjFormSubmit('uploadDocumentERROR');
        return false;
      }
    });
  }
}
